import { render, staticRenderFns } from "./EditMenuSettings.vue?vue&type=template&id=b0121ec8&scoped=true&"
import script from "./EditMenuSettings.vue?vue&type=script&lang=js&"
export * from "./EditMenuSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditMenuSettings.vue?vue&type=style&index=0&id=b0121ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0121ec8",
  null
  
)

export default component.exports